<template>
  <div class="page-content detail">
    <div class="form-title">
      <i class="icon" :class="currentMenu.imgUrl||'el-icon-document'" ></i>
      {{title}}详情
      <el-button
        plain
        type="primary"
        @click="backParent"
      >返回</el-button>
      <span class="btn-box" v-if="detailOptions.toolConfig">
          <el-button v-for="btn in detailOptions.toolConfig" plain type="primary"
          :key="btn.code" @click="btnClick(btn)">{{btn.label||btn.name}}</el-button>
      </span>
<!--      <span-->
<!--        class="back-txt fr el-icon-d-arrow-left"-->
<!--        @click="backParent"-->
<!--      >返回</span>-->
    </div>
    <div id="detailInfo">
      <el-form
        class="form-box"
        v-loading="loading"
      >
        <div
          v-show="detailOptions.statusOption"
          class="status-image"
          :style="detailStyle"
        ></div>
        <el-row>
          <el-col
            v-for="(column,index) in detailOptions.columns"
            :key="index"
            :span="column.isAllline ? 24 : (column.span||detailOptions.span)"
            :style="column.style"
          >
            <el-col :span="column.isAllline ? (column.span||detailOptions.span) : 24">
              <el-form-item
                :label="column.label"
                :label-width="column.label.length>0 ? detailOptions.labelWidth:'0px'"
              >
                <!--文件上传-->
                <file-upload
                  :ref="column.prop"
                  :disabledProp="true"
                  v-if="column.type === columnType.uploadFile"
                  :fileOptions="column"
                ></file-upload>
                <img
                  class="detail-img"
                  @click="itemFun(column.click, detailOptions.formData)"
                  v-else-if="column.type && column.type === columnType.image"
                  :src="column.defaultValue ? column.defaultValue : (detailOptions.formData&& detailOptions.formData[column.prop])"
                />
                <span
                  v-else-if="column.merge"
                  v-for="(p,index) in column.prop.split(',')"
                  :key="index"
                >
                  {{detailOptions.formData&&detailOptions.formData[p]}}
                </span>
                <div
                  v-else-if="column.enumData"
                  v-html="$utils.getEnumItem(column,detailOptions.formData&&detailOptions.formData[column.prop])"
                ></div>
                <span v-else-if="column.deal">{{column.deal(detailOptions.formData && detailOptions.formData[column.prop])}}</span>
                <span v-else>{{ detailOptions.formData&&detailOptions.formData[column.prop]}}</span>
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>
      </el-form>
      <div
        v-for="(tableOptions,tbindex) in detailOptions.tablesProp"
        :key="tbindex"
        class="detail-table-box"
      >
        <list-template
          :tableData="tableData[tbindex]"
          :tableOptions="tableOptions"
        ></list-template>
      </div>
    </div>
  </div>
</template>
<script>
import listTemplate from "./listTemplate";
export default {
  components: {
    listTemplate
  },
  data() {
    return {
      loading: false,
      detailOptions: { formData: {} },
      currentMenu: {},
      tableData: {}, //表格数据层次太深，需要在当前对象中创建
      title: "",
      detailStyle: {},
      columnType: {
        image: "image", //图片
        file: "file", //图片
        uploadFile: "uploadFile",
      },
    };
  },
  created() {
    this.currentMenu = this.$utils.getCurrentMune();
    this.title = document.title;
    if (
      this.$store.state[this.$utils.storeKeys.FORMINFO] &&
      Object.keys(this.$store.state[this.$utils.storeKeys.FORMINFO]).length > 0
    ) {
      this.detailOptions = this.$store.state[this.$utils.storeKeys.FORMINFO];
      this.getDetail();
    } else {
      this.backParent();
    }
  },
  methods: {
    btnClick(btn){
      btn.callback(this.$route.query.id,this.detailOptions.formData,this.tableData);
    },
    itemFun(bindFun, data) {
      bindFun && bindFun(data);
    },
    getDetail() {
      this.loading = true;
      this.$axios
        .fetchGet(this.detailOptions.url + "?id=" + this.$route.query.id, {})
        .then((data) => {
          this.loading = false;
          if (data.code == 200 && data.data) {
            this.detailOptions.formData = data.data;
            // 表格数据
            this.detailOptions.tablesProp &&
              Object.keys(this.detailOptions.tablesProp).map((key) => {
                if(Array.isArray){
              if(Array.isArray(data.data[key])){
                data.data[key].forEach((item,index)=>{
                  item.indexShow = index + 1;
              });
                this.$set(this.tableData, key, data.data[key]);
              }
            }else{
              this.$set(this.tableData, key, data.data[key]);
            }
              });
            //图片状态
            if (this.detailOptions.statusOption) {
              this.detailStyle = {
                backgroundImage:
                  "url(" +
                  this.detailOptions.statusOption.statusImg[
                    this.detailOptions.formData &&
                      this.detailOptions.formData[
                        this.detailOptions.statusOption.prop
                      ]
                  ] +
                  ")",
                left: this.detailOptions.statusOption.left || "unset",
                right: this.detailOptions.statusOption.right || "unset",
                top: this.detailOptions.statusOption.top || "unset",
                bottom: this.detailOptions.statusOption.bottom || "unset",
              };
            }
            this.$nextTick(() => {
              this.detailOptions.columns.map((item) => {
                if (
                  item.type === this.columnType.uploadFile &&
                  data.data.attachments
                ) {
                  // 文件上传
                  this.$refs[item.prop][0].fileList =
                    data.data.attachments[item.prop];
                  this.$refs[item.prop][0].disabled = true;
                }
              });
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    backParent() {
      if (this.$route.path == this.$route.query.redirect) return;
      this.$router.push({ path: this.$route.query.redirect });
    },
  },
};
</script>
<style>
.detail.page-content .form-title .back-txt {
  color: #409eff;
  font-size: 14px;
  margin-right: 10px;
  margin-left: 10px;
  cursor: pointer;
}
.detail.page-content .form-box {
  padding:10px 20px;
}
.detail.page-content .detail-table-box {
  padding:0 20px 20px 20px;
  border-radius: 5px;
  max-width: 100%;
}
.detail.page-content .form-box .el-form-item {
  min-height: unset;
}
.detail.page-content .form-box .el-form-item .el-form-item__content{
  line-height: 30px;
}
.detail.page-content .form-box {
  min-height: unset;
  position: relative;
}
.detail.page-content .detail-img {
  width: 50px;
}
.detail.page-content {
  padding-bottom: 30px;
}
.page-content.detail .status-image {
  position: absolute;
  top: 0px;
  right: 100px;
  width: 164px;
  height: 87px;
  background-size: 100% 100%;
  z-index: 1000;
}
.page-content.detail .btn-box{
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/template/detail.vue